import EmailReceiveAlertAPI from '@/api/EmailReceiveAlertAPI.js';
import httpClient from '@/api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	getEmailReceiveAlertsAsync: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: EmailReceiveAlertAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true
		);
		if (res && res.Data) {
			context.commit('updateEmailReceiveAlerts', res.Data);
			return res.Data;
		}
		return res;
	},

	getEmailReceiveAlertAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: EmailReceiveAlertAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload.OrgReceiveId}`
		});
		if (res && res.Data) {
			context.commit('updateEmailReceiveAlert', res.Data);
		}
	},

	insertEmailReceiveAlertAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailReceiveAlertAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/insert`,
			data: payload
		});
		return res;
	},

	insertEmailReceiveAlertsAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailReceiveAlertAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/insert-many`,
			data: payload
		});
		return res;
	},

	updateEmailReceiveAlertAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: EmailReceiveAlertAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/update`,
			data: payload
		});
		return res;
	},

	deleteEmailReceiveAlertAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: EmailReceiveAlertAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/delete/${payload.id}`
		});
		return res;
	}
};
